import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskSSN(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      mask="999-99-9999"
      onChange={onChange}
    />
  );
}

InputMaskSSN.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskSSN.js